<template>
	<nav class="navigation">
		<span class="navigation__links">
			<img
				src="../assets/logo.png"
				class="navigation__logo"
				style="cursor: pointer;"
				alt="logo"
				@click="gotoIntro"
			/>

			<h3
				class="navigation__browse"
				v-if="!showlogin"
				style="cursor: pointer;"
				@click="gotoLogin"
			>
				Login
			</h3>
			<h3
				class="navigation__browse"
				v-if="showlogin"
				style="cursor: pointer;"
				@click="gotoSearch"
			>
				Search
			</h3>
		</span>
		<div class="user-container">
			<div class="dropdown user-container__user" v-if="showlogin">
				<h5 class="user">{{ user }}</h5>
				<div class="dropdown-content">
					<div @click="logout" class="c-border-bottom items-drop">Logout</div>
					<div class="items-drop" @click="goToaccount">Account</div>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
export default {
	name: "Navbar",
	data() {
		return {};
	},
	computed: {
		user() {
			return this.$store.state.user.userInfo.name;
		},
		showlogin() {
			return this.$store.state.user.logedin;
		},
		showHome() {
			if (this.$router.name) {
				return true;
			}
		},
	},
	methods: {
		logout() {
			this.$store.dispatch("logout").then((res) => {
				if (res == "true") {
					this.$router.push("/");
				}
			});
		},
		gotoLogin() {
			this.$router.push("/login");
		},
		gotoIntro() {
			this.$router.push("/");
		},
		gotoHome() {
			this.$router.push("/home");
		},
		gotoSearch() {
			this.$router.push("/search");
		},
		goToaccount() {
			this.$router.push("/account");
		},
	},
};
</script>

<style lang="scss">
.navigation {
	display: flex;
	position: fixed;
	top: 0;
	width: 100%;
	background-color: rgb(18, 25, 24);
	align-items: center;
	justify-content: space-between;
	z-index: 2000;
	&__links {
		display: flex;
	}
	&__logo {
		height: 40px;
		margin: 13px 3vw 10px 13px;
	}
	&__browse {
		color: #d81f26;
	}
}

.search-container {
	height: 50px;
	display: flex;
	align-items: center;
	margin: 13px 15px 10px 0;
	&__btn {
		font-size: 1.3em;
		color: white;
	}
}

.user-container {
	height: 50px;
	display: flex;
	align-items: center;
	margin: 13px 15px 10px 0;
	&__image {
		height: 35px;
		margin-right: 20px;
	}
	&__user {
		font-size: 1.3em;
		color: white;
	}
}
.dropdown {
	position: relative;
	display: inline-block;
}

.dropdown-content {
	display: none;
	position: absolute;
	background-color: #121918;
	width: 100%;
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
	padding: 10px;
	z-index: 1;
	text-align: center;
}
.dropdown-content ul {
	list-style: none;
}
.dropdown:hover .dropdown-content {
	display: block;
	cursor: pointer;
}
.items-drop {
	padding: 10px;
	line-height: 30px;
}
</style>
<style scoped>
.margin-left {
	margin-left: 30px;
}
.c-border-bottom {
	border-bottom: 1px solid #fff;
}
</style>
